/* ─── theme.js — VINNARE ───
   JS mínimo: mobile nav, cart count, quick add, overlay
   Sin dependencias externas
──────────────────────────────────────── */

(function () {
  'use strict';

  /* ── Fetch API Helpers (Bulletproof ATC) ── */
  const SHOPIFY_FETCH_OPTS = {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  async function fetchCartWithRetry(retriesLeft = 3, delayMs = 350) {
    const res = await fetch(`/cart/update.js`, {
      method: 'POST',
      ...SHOPIFY_FETCH_OPTS,
      body: JSON.stringify({})
    });
    const cart = await res.json();
    if (cart.item_count === 0 && retriesLeft > 0) {
      console.warn(`[Vinnare] Carrito vacío recibido. Reintentando en ${delayMs}ms... (${retriesLeft} restantes)`);
      await delay(delayMs);
      return fetchCartWithRetry(retriesLeft - 1, delayMs * 1.5);
    }
    return cart;
  }

  async function addToCartAndFetch(variantId, quantity = 1) {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      ...SHOPIFY_FETCH_OPTS,
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!addRes.ok) {
      const err = await addRes.json();
      throw new Error(err.description || 'Error al agregar al carrito');
    }
    return fetchCartWithRetry(3);
  }

  async function changeCartAndFetch(line, quantity) {
    const changeRes = await fetch('/cart/change.js', {
      method: 'POST',
      ...SHOPIFY_FETCH_OPTS,
      body: JSON.stringify({ line: parseInt(line), quantity })
    });
    if (!changeRes.ok) throw new Error('Cart change failed');
    return fetchCartWithRetry(3);
  }

  window.addToCartAndFetch = addToCartAndFetch;
  window.fetchCartWithRetry = fetchCartWithRetry;

  /* ── Mobile nav ── */
  const nav      = document.getElementById('mobile-nav');
  const overlay  = document.getElementById('overlay');
  const btnOpen  = document.getElementById('mobile-nav-open');
  const btnClose = document.getElementById('mobile-nav-close');

  function openNav() {
    if (!nav) return;
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    btnOpen && btnOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    btnOpen && btnOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  window.closeNav = closeNav;
  btnOpen  && btnOpen.addEventListener('click', openNav);
  btnClose && btnClose.addEventListener('click', closeNav);
  overlay  && overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* ── Header sticky ── */
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('header--scrolled', window.scrollY > 100);
    }, { passive: true });
  }

  /* ── Cart count ── */
  function updateCartCount() {
    fetchCartWithRetry(0).then(function (cart) {
      document.querySelectorAll('[data-count]').forEach(function (el) {
        el.setAttribute('data-count', cart.item_count);
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function () {});
  }
  updateCartCount();

  /* ── Cart Drawer ── */
  const cartDrawer        = document.getElementById('cart-drawer');
  const cartDrawerClose   = document.getElementById('cart-drawer-close');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartDrawerClose)   cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  const headerCartBtn = document.getElementById('header-cart-btn');
  if (headerCartBtn) {
    headerCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  document.addEventListener('click', function(e) {
    const t = e.target.closest('[href="/cart"], .header__cart-btn');
    if (!t) return;
    if (t.closest('#cart-drawer')) return;
    if (t.href && t.href.includes('/checkout')) return;
    e.preventDefault();
    openCartDrawer();
  });

  function formatMoney(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-UY', { minimumFractionDigits: 2 }) + ' UYU';
  }

  /* ── updateCartDrawerUI ── */
  function updateCartDrawerUI(cart) {

    // 1. Contador del header y título del drawer
    document.querySelectorAll('[data-count]').forEach(el => {
      el.setAttribute('data-count', cart.item_count);
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    const titleEl = document.getElementById('cart-drawer-title');
    if (titleEl) titleEl.textContent = `Tu carrito (${cart.item_count})`;

    // 2. Barra de beneficios
    const LEVELS = [
      { id: 'vn-lvl-1', threshold: 250000 },
      { id: 'vn-lvl-2', threshold: 400000 },
      { id: 'vn-lvl-3', threshold: 500000 },
    ];
    const MAX_THRESHOLD = 500000;

    const progressEl = document.getElementById('shipping-bar-progress');
    const textEl     = document.getElementById('shipping-bar-text');

    if (progressEl) {
      const pct = Math.min((cart.total_price / MAX_THRESHOLD) * 100, 100);
      progressEl.style.width = pct + '%';
    }

    LEVELS.forEach(function(lvl) {
      const el = document.getElementById(lvl.id);
      if (!el) return;
      el.classList.toggle('reached', cart.total_price >= lvl.threshold);
    });

    if (textEl) {
      if (cart.total_price >= 500000) {
        textEl.innerHTML = '<strong style="color:#16a34a">¡Todo desbloqueado!</strong> Lentes + prenda + envío gratis incluidos';
      } else if (cart.total_price >= 400000) {
        textEl.innerHTML = `Nivel 2 activo — te faltan <strong>${formatMoney(500000 - cart.total_price)}</strong> para sumar <strong>envío gratis</strong>`;
      } else if (cart.total_price >= 250000) {
        textEl.innerHTML = `Nivel 1 activo — te faltan <strong>${formatMoney(400000 - cart.total_price)}</strong> para sumar <strong>prenda de regalo</strong>`;
      } else {
        textEl.innerHTML = `Te faltan <strong>${formatMoney(250000 - cart.total_price)}</strong> para desbloquear <strong>lentes de regalo</strong>`;
      }
    }

    // 3. Items
    const itemsContainer = document.getElementById('cart-drawer-items');
    const subtotalEl     = document.getElementById('cart-drawer-subtotal');
    const footContainer  = document.getElementById('cart-drawer-foot');
    const emptyContainer = document.getElementById('cart-drawer-empty');

    if (!itemsContainer || !subtotalEl) return;

    subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.items.length === 0) {
      itemsContainer.style.display = 'none';
      if (footContainer)  footContainer.style.display  = 'none';
      if (emptyContainer) emptyContainer.style.display = 'flex';
      return;
    } else {
      itemsContainer.style.display = '';
      if (footContainer)  footContainer.style.display  = '';
      if (emptyContainer) emptyContainer.style.display = 'none';
    }

    let html = '';
    cart.items.forEach((item, index) => {
      const lineIndex    = index + 1;
      const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : '';
      html += `
        <div class="cart-drawer__item" data-line="${lineIndex}">
          <div class="cart-drawer__item-img">
            ${item.image
              ? `<img src="${item.image}" alt="${item.title || 'Producto'}">`
              : '<div style="width:100%;height:100%;background:#ebebeb;"></div>'}
          </div>
          <div>
            <p class="cart-drawer__item-name">${item.product_title || item.title || 'Producto'}</p>
            ${variantLabel}
            <div class="cart-drawer__item-bottom">
              <div class="cart-drawer__qty">
                <button class="cart-drawer__qty-btn" data-line="${lineIndex}" data-action="dec">−</button>
                <span class="cart-drawer__qty-val">${item.quantity}</span>
                <button class="cart-drawer__qty-btn" data-line="${lineIndex}" data-action="inc">+</button>
              </div>
              <span class="cart-drawer__item-price">${formatMoney(item.final_line_price != null ? item.final_line_price : (item.line_price || item.price || 0))}</span>
            </div>
          </div>
        </div>
      `;
    });
    itemsContainer.innerHTML = html;
  }

  /* ── Event delegation drawer ── */
  document.addEventListener('click', function(e) {
    if (e.target.closest('#cart-drawer-close') || e.target.closest('.cart-drawer__overlay')) {
      closeCartDrawer();
      return;
    }

    const qtyBtn = e.target.closest('.cart-drawer__qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      const line      = qtyBtn.dataset.line;
      const action    = qtyBtn.dataset.action;
      const qtyEl     = qtyBtn.parentElement.querySelector('.cart-drawer__qty-val');
      if (!qtyEl) return;
      const currentQty = parseInt(qtyEl.textContent);
      const newQty     = action === 'inc' ? currentQty + 1 : Math.max(0, currentQty - 1);

      qtyBtn.disabled = true;
      changeCartAndFetch(line, newQty)
        .then(function(cart) { window.updateCartDrawerUI(cart); })
        .catch(function(err) {
          console.error(err);
          qtyBtn.disabled = false;
          fetchCartWithRetry(1).then(cart => window.updateCartDrawerUI(cart));
        });
      return;
    }

    const removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.dataset.line;
      changeCartAndFetch(line, 0)
        .then(cart => window.updateCartDrawerUI(cart))
        .catch(console.error);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  window.updateCartDrawerUI = updateCartDrawerUI;
  window.openCartDrawer     = openCartDrawer;
  window.closeCartDrawer    = closeCartDrawer;

  /* ── Quick Add ── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'Agregando...';

    addToCartAndFetch(variantId, 1)
      .then(cart => {
        btn.textContent = '✓ Agregado';
        window.updateCartDrawerUI(cart);
        window.openCartDrawer();
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(() => {
        btn.textContent = 'Sin stock';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      });
  });

  /* ── Init ── */
  fetchCartWithRetry(0)
    .then(cart => updateCartDrawerUI(cart))
    .catch(console.error);

  /* ── Animaciones on-scroll ── */
  const animEls = document.querySelectorAll('.card, .mistery-card, .collection-card');
  if ('IntersectionObserver' in window && animEls.length) {
    const style = document.createElement('style');
    style.textContent = `
      .vn-fade { opacity: 0; transform: translateY(20px); transition: opacity 400ms ease, transform 400ms ease; }
      .vn-fade.vn-visible { opacity: 1; transform: translateY(0); }
    `;
    document.head.appendChild(style);
    animEls.forEach(function (el) { el.classList.add('vn-fade'); });

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vn-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    animEls.forEach(function (el) { io.observe(el); });
  }

  /* ── Instagram FAB ── */
  const wppFab = document.getElementById('piolaWppFab');
  if (wppFab) {
    window.addEventListener('scroll', function() {
      wppFab.classList.toggle('is-visible', window.scrollY > 150);
    }, { passive: true });
  }

  /* ── Bloqueo Ctrl+Shift+T ── */
  document.addEventListener('keydown', function(e) {
    if (e.ctrlKey && e.shiftKey && (e.key === 'T' || e.key === 't')) {
      e.preventDefault();
      e.stopPropagation();
      console.log('[Vinnare] Atajo Ctrl+Shift+T bloqueado.');
    }
  }, true);

  /* ── Fix links Members y Contacto ── */
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const text = link.textContent.toLowerCase();

    if (text.includes('members')) {
      const target = document.getElementById('vn-members-section');
      if (target && window.location.pathname === '/') {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        if (typeof window.closeNav === 'function') window.closeNav();
      } else if (window.location.pathname !== '/') {
        link.setAttribute('href', '/#vn-members-section');
      }
    }

    if (text.includes('contacto')) {
      e.preventDefault();
      window.location.href = 'https://www.instagram.com/vinnare.uy/';
    }
  });

})();